import {
    BookingAttemptDataDto,
    BookingAttemptDto,
    BookingAttemptMetricsDto
} from 'actions/bookingAttempts/BookingAttemptsDto';
import { BookingAttempt, BookingAttemptData, BookingAttemptMetrics, BookingAttemptType } from 'model/BookingAttempt';
import { OnlineBookingStep, OnlineBookingStepNames } from 'model/OnlineBooking';
import moment from 'moment-timezone';

export const convertToBookingAttempt = (dto: BookingAttemptDto, timeZone: string): BookingAttempt => ({
    id: dto.id,
    name: dto.name,
    email: dto.email,
    phone: dto.phone,
    type: dto.type as BookingAttemptType,
    pets: dto.pets,
    customerId: dto.customer_id,
    bookingData: convertToBookingAttemptData(dto.booking_data, timeZone),
    abandonedStepName: OnlineBookingStepNames[dto.abandoned_step as OnlineBookingStep],
    abandonedStep: dto.abandoned_step as OnlineBookingStep,
    abandonedDate: moment(dto.abandoned_date).tz(timeZone)
});

export const convertToBookingAttemptData = (dto: BookingAttemptDataDto, timeZone: string): BookingAttemptData => ({
    date: dto.date,
    time: dto.time,
    notes: dto.notes,
    staffId: dto.staffId,
    dateTime:
        dto.date && dto.time ? moment(`${dto.date} ${dto.time}`, 'YYYY-MM-DD HH:mm A').tz(timeZone, true) : undefined,
    bookingItems: dto.bookingItems?.map(item => ({
        petId: item.petId,
        serviceId: item.serviceId,
        addons: item.addons
    }))
});

export const convertToBookingAttemptMetrics = (dto: BookingAttemptMetricsDto): BookingAttemptMetrics => ({
    totalCount: dto.total_abandoned,
    convertedCount: dto.converted,
    convertedValue: dto.converted_value
});
